import { Comparison } from './pages/Comparison';

function App() {
  return <Comparison />;
}

export default App;
